export default {
  namespaced: true,
  state: {
    currentGalleryItemIndex: 0,
    currentVariantIndex: 0,
    isAllItemsExpanded: false,
    isGalleryOpen: false,
    product: {},
    scrollPosition: 0,
  },

  mutations: {
    openGallery(state, payload) {
      state.isGalleryOpen = payload
    },

    setAllItemsExpanded(state, payload) {
      state.isAllItemsExpanded = payload
    },

    setCurrentCaptionIndex(state, payload) {
      state.lastCaptionIndex = state.currentCaptionIndex
      state.currentCaptionIndex = payload
    },

    setCurrentGalleryItemIndex(state, payload) {
      state.currentGalleryItemIndex = payload
    },

    setProduct(state, payload) {
      state.product = payload
    },

    setScrollposition(state, payload) {
      state.scrollPosition = payload
    },
  },

  actions: {},

  getters: {
    currentGalleryItemIndex: state => state.currentGalleryItemIndex,
    currentVariant: state => state.product.variants[state.currentVariantIndex],
    currentVariantIndex: state => state.currentVariantIndex,
    currentCaptionIndex: state => state.currentCaptionIndex,
    isAllItemsExpanded: state => state.isAllItemsExpanded,
    isGalleryOpen: state => state.isGalleryOpen,
    lastCaptionIndex: state => state.lastCaptionIndex,
    product: state => state.product,
    scrollPosition: state => state.scrollPosition,
  },
}
